'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _propTypes = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _updateFields = require('../actions/update-fields');
var _employmentLookup = require('../components/employment-lookup');
var _employmentLookup2 = _interopRequireDefault(_employmentLookup);
var _radio = require('../components/radio');
var _radio2 = _interopRequireDefault(_radio);
var _withFormId = require('../hocs/with-form-id');
var _withFormId2 = _interopRequireDefault(_withFormId);
var _fieldInfo = require('../selectors/field-info');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Employment = function (_Component) {
  _inherits(Employment, _Component);
  function Employment() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, Employment);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Employment.__proto__ || Object.getPrototypeOf(Employment)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function () {
      _this.props.resetFields(_this.props.formId, ['occupation', 'occupationText', 'industry', 'industryText']);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(Employment, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', null, _react2.default.createElement(_radio2.default, {
        name: 'employmentStatus',
        label: 'Employment status',
        options: this.props.options,
        onChange: this.handleChange
      }), this.props.captureExtraData ? _react2.default.createElement(_employmentLookup2.default, null) : null);
    }
  }]);
  return Employment;
}(_react.Component);
Employment.propTypes = {
  formId: _propTypes.string.isRequired,
  options: _propTypes.array,
  captureExtraData: _propTypes.bool.isRequired,
  resetFields: _propTypes.func.isRequired
};
Employment.defaultProps = {
  options: []
};
exports.default = (0, _withFormId2.default)((0, _reactRedux.connect)(function (state, ownProps) {
  var chosenOption = ownProps.options.find(function (option) {
    return option.value === (0, _fieldInfo.getValue)(state, ownProps.formId, 'employmentStatus');
  });
  return {
    captureExtraData: !!chosenOption && chosenOption.captureExtraData === 1
  };
}, {
  resetFields: _updateFields.resetFields
})(Employment));